//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/**
 * Navigates the browser to the given URL.
 * Extracted from call sites so it can be mocked in unit tests without
 * wrestling with JSDOM's non-writable window.location.
 */
export function navigateTo(url: string): void {
  window.location.assign(url);
}
